// Port of api/fuel/app/classes/filter/search/games/rules/query/collection_wantparts_text.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'collection_wantparts_text',
	contains: function(rule, config, filter, data, query) {
		var keywords = Rule.getKeywords(Rule.value(rule))
		var opMap = Rule.operandMapped(rule, { '=': 'like', '!=': 'not like' })
		for (var i = 0; i < keywords.length; i++) {
			query.where('c.collection_wantparts_text', opMap, '%' + keywords[i] + '%')
		}
	}
})
